import { SPACE_REGEX_G } from './text-utils';
export default class ExpandableAbbreviations {
    constructor(editorController) {
        this.handleTextChanged = (delta, source) => {
            var _a, _b, _c, _d, _e, _f, _g;
            if (!this.enabled)
                return;
            const isDelete = ((_a = delta.ops[0]) === null || _a === void 0 ? void 0 : _a.delete) !== undefined || ((_b = delta.ops[1]) === null || _b === void 0 ? void 0 : _b.delete) !== undefined;
            const isApiUser = source === 'api';
            const isBufferActive = this.buffer !== null;
            // NOTE: API change or user deletes characters while buffer is active (!== null)
            if (isApiUser || (isDelete && isBufferActive)) {
                this.updateBufferFromCurrentWord();
                return;
            }
            // NOTE: The delta of the first character has a different order of ops. The insert operation
            // is on index 0 for the first char in contrast to other chars, where the index of insert
            // operation is on index 1.
            const firstInsert = (_c = delta.ops[0]) === null || _c === void 0 ? void 0 : _c.insert;
            if (firstInsert !== undefined) {
                // NOTE: User inserts empty spaces at the beginning of the document
                if (firstInsert.toString().match(SPACE_REGEX_G) !== null) {
                    this.buffer = null;
                    return;
                }
                // NOTE: User inserts first character at the beginning of the document
                this.buffer = {
                    index: 0,
                    insert: firstInsert.toString(),
                };
                return;
            }
            // NOTE: This catches newline insertion (Enter) or operations without insert
            const isOtherOpsThanInsert = ((_d = delta.ops[1]) === null || _d === void 0 ? void 0 : _d.insert) === undefined || ((_e = delta.ops[1]) === null || _e === void 0 ? void 0 : _e.insert.toString()) === '\n';
            // NOTE: User does anything besides deleting and inserting.
            if (isOtherOpsThanInsert && this.buffer !== null) {
                this.buffer = null;
                return;
            }
            const otherInsert = (_f = delta.ops[1]) === null || _f === void 0 ? void 0 : _f.insert;
            if (otherInsert !== undefined) {
                // NOTE: Add only chars of length 1 to the buffer.
                if (otherInsert.toString().length > 1)
                    return;
                // NOTE: User inserts empty space anywhere in the editor except at the beginning.
                if (otherInsert.toString().match(SPACE_REGEX_G) !== null && this.buffer === null) {
                    return;
                }
                // NOTE: First typed character (not at document start) — initialize buffer
                if (this.buffer === null) {
                    this.buffer = {
                        index: (_g = delta.ops[0].retain) !== null && _g !== void 0 ? _g : 0,
                        insert: otherInsert.toString(),
                    };
                    return;
                }
                // NOTE: User keeps inserting characters (continuing the word)
                this.buffer.insert = [this.buffer.insert, otherInsert].join('');
                return;
            }
            // NOTE: Fallback for all other operations
            this.buffer = null;
        };
        this.handleEventKeySpace = () => {
            if (!this.enabled)
                return;
            if (this.buffer === null || this.abbreviationsList === null)
                return;
            for (let index = 0; index < this.abbreviationsList.length; index += 1) {
                if (this.abbreviationsList[index].abbreviation === this.buffer.insert) {
                    const expandedWord = this.abbreviationsList[index].text;
                    const prevBuffer = this.buffer;
                    // NOTE: .deleteText() will reset the buffer.
                    this.editorController.deleteText(this.buffer.index, this.buffer.insert.length);
                    this.editorController.insertText(prevBuffer.index, expandedWord);
                    this.editorController.setSelection(prevBuffer.index + expandedWord.length, 0);
                    return;
                }
            }
            this.handleSelectionChanged();
        };
        this.handleSelectionChanged = () => {
            if (!this.enabled || this.buffer === null)
                return;
            this.buffer = null;
        };
        this.editorController = editorController;
        this.enabled = false;
        this.buffer = null;
        this.abbreviationsList = null;
    }
    setEnabled(enabled) {
        if (this.enabled === enabled)
            return;
        this.enabled = enabled;
    }
    setAbbreviationsList(abbreviations) {
        if (!this.enabled)
            return;
        if (abbreviations.length === 0)
            return;
        this.abbreviationsList = abbreviations;
    }
    updateBufferFromCurrentWord() {
        const selection = this.editorController.getSelection();
        if (selection === null || selection.index === 0) {
            this.buffer = null;
            return;
        }
        const { index } = selection;
        const textBefore = this.editorController.getText(0, index);
        const match = textBefore.match(/(\S+)$/);
        if (match !== null) {
            this.buffer = {
                index: index - match[1].length,
                insert: match[1],
            };
        }
        else {
            this.buffer = null;
        }
    }
}
